// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-divider[data-v-f1174694]{background:linear-gradient(90deg,transparent,rgba(63,81,181,.18) 20%,rgba(244,67,54,.15) 80%,transparent);height:1px;margin:0 auto;max-width:900px;width:80%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
